import Card from "../../../../components/Card/Card";
import "./TrainingDetailsHeader.scss";
import useTrainingDetails from "../../logic/useTrainingDetails";
import { formatDate } from "../../../../utils/dateFormatter";

function TrainingDetailsHeader() {
  const { trainingData } = useTrainingDetails();

  let imgCourse = `${process.env.REACT_APP_CORE_PATH}/courses/images/${trainingData?.course?.imagePath}`;

  return (
    <div
      className="training-header"
      style={{
        backgroundImage: imgCourse
          ? `url(${imgCourse})`
          : "https://www.pulsecarshalton.co.uk/wp-content/uploads/2016/08/jk-placeholder-image.jpg",
      }}
    >
      <div className="training-information-overlay">
        <Card>
          <div className="training-participate-card">
            <h2>Date & Time</h2>
            <div className="training-date">
              <label>From : {formatDate(trainingData?.start_date)}</label>
              <label>To : {formatDate(trainingData?.end_date)}</label>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
export default TrainingDetailsHeader;
